import { Controller } from "@hotwired/stimulus"

// A poster with a play button. The YouTube player is only created when the visitor asks for it,
// so the page does not pay for an embedded player (and its trackers) before anyone presses play.
export default class extends Controller {
  static targets = ["poster"]
  static values = { src: String, title: String }

  play() {
    const frame = document.createElement("iframe")
    frame.src = this.srcValue
    frame.title = this.titleValue
    frame.allow = "autoplay; encrypted-media; picture-in-picture; fullscreen"
    frame.allowFullscreen = true
    frame.referrerPolicy = "strict-origin-when-cross-origin"
    frame.className = "bw-video__frame"
    this.posterTarget.replaceWith(frame)
  }
}
